import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-view_open",
  "use": "icon-view_open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-view_open\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M6,12a6.1,6.1,0,0,1,12,0A6.1,6.1,0,0,1,6,12Zm6,2.77A2.77,2.77,0,1,0,9.23,12,2.77,2.77,0,0,0,12,14.77Zm0-1.11A1.66,1.66,0,1,1,13.66,12,1.66,1.66,0,0,1,12,13.66Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol